module.exports = __webpack_public_path__ + "img/basket3-fill.f94794a9.svg";